import React, { useContext } from "react";
import { Connection } from "../models";

const ConnectionsStatusContext = React.createContext<Connection[]>([]);

export const ConnectionsStatusProvider = ConnectionsStatusContext.Provider;
export const ConnectionsStatusConsumer = ConnectionsStatusContext.Consumer;

/**
 * Accesses the ConnectionsStatusContext and returns selected connections.
 */
export const useConnections = () => {
  const connections = useContext(ConnectionsStatusContext);

  const webServices = connections?.find((c) => c.name === "Web Services");
  const powerPick = connections?.find((c) => c.name === "PowerPick");

  return { webServices, powerPick };
};

export default ConnectionsStatusContext;
